import React from 'react';
import Verify from '../components/Verify';
import VERIFICATION_TYPES from './../types';

const VerifySenderEmail = () => <Verify type={VERIFICATION_TYPES.SENDER} />;

export default VerifySenderEmail;
